import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button'



export default class Redeem extends Component {
	state ={
		code: null,
		deals: null,
		confirm: ''
	}
	mongo = process.env.REACT_APP_MONGO

	componentDidMount() {

		this.loadDeals()

	}

	loadDeals = () => {
		let query = {
	    	"uid": this.props.uid
	    }

		let mongoAPI = null

		// check if test account
	    if(this.props.uid === "jHtNRFNFUsW3pdBLenqBHnwYbnk1"){

	      mongoAPI = "https://api.mlab.com/api/1/databases/funily/collections/test?apiKey=" + this.mongo + "&q=" + JSON.stringify(query)

	    } else {

	      mongoAPI = "https://api.mlab.com/api/1/databases/funily/collections/deals?apiKey=" + this.mongo + "&q=" + JSON.stringify(query)

	    }

	    // grab all deals by the vendor based on UID
	    fetch(mongoAPI)
	    .then(res => { return res.json()})
	    .then(function(jsonRes){
	    	this.setState({deals: jsonRes}, () => console.log('vendor deals',this.state.deals))
	    }.bind(this))
	     .catch(err => console.log('error loading deals'))
	}

	handleChange = event => {
		this.setState({code: event.target.value})
	}

	handleSubmit = (e) => {
		e.preventDefault();
		let mongoAPI = null
		let { deals } = this.state

		console.log(deals)

	    // check if test account
	    if(this.props.uid === "jHtNRFNFUsW3pdBLenqBHnwYbnk1"){
	      mongoAPI = "https://api.mlab.com/api/1/databases/funily/collections/test?apiKey=" + this.mongo
	    } else {
	      mongoAPI = "https://api.mlab.com/api/1/databases/funily/collections/deals?apiKey=" + this.mongo
	    }

	    var codes = {}

	    var findCode = deals.some(item => {
		    	if(item.deal_ids){
		    		if(item.deal_ids.includes(this.state.code)){
			     		codes.dealCode = item.deal_code
			     		codes.redeemCode = this.state.code
			     		return true
			     	}
		    	}
		    })

	    if(findCode){
	    	this.setState({confirm:"Deal Code Found!"}, ()=> {
	    		this.updateDealRedemptions(codes.dealCode,codes.redeemCode)
	    		setTimeout(function(){
	    			this.setState({confirm:''})
	    		}.bind(this),2000)
	    	})
	    } else {
	    	this.setState({confirm:"Invalid Deal Code"},() => {
	    		setTimeout(function(){
	    			this.setState({confirm:''})
	    		}.bind(this),2000)
	    	})
	    }

		e.target.reset()
	}

	updateDealRedemptions = (dealCode,redeemCode) => {
		let mongoAPI = null
		let db = ''
		// check if test account
	    if(this.props.uid === "jHtNRFNFUsW3pdBLenqBHnwYbnk1"){
	      mongoAPI = "https://api.mlab.com/api/1/databases/funily/runCommand?apiKey=" + this.mongo
	      db = 'test'
	    } else {
	      mongoAPI = "https://api.mlab.com/api/1/databases/funily/runComman?apiKey=" + this.mongo
	      db = 'deals'
	    }

	    let toUpdate = {
	    	findAndModify: db,
			sort: { dea_code: 1 },
			query: {
				deal_code: dealCode
			},
			update: {
				$addToSet: {
					redemptions: redeemCode
				}
			}
	    }

	    fetch(mongoAPI,{
	    	method: "POST",
	    	headers: {
	    		"Accept": "application/json",
	    		"Content-Type": 'application/json'
	    	},
	    	body: JSON.stringify(toUpdate)
	    }).then(res => {return res.json()})
	      .then(function(jsonRes){
	      	this.removeRedeemCode(dealCode,redeemCode)
	      	console.log('jsonRes',jsonRes)

	  	  }.bind(this))
	      .catch(err => console.log('error adding redemptions', err))

	}

	removeRedeemCode = (dealCode,redeemCode) => {
		let mongoAPI = null
		let db = ''
		// check if test account
	    if(this.props.uid === "jHtNRFNFUsW3pdBLenqBHnwYbnk1"){
	      mongoAPI = "https://api.mlab.com/api/1/databases/funily/runCommand?apiKey=" + this.mongo
	      db = 'test'
	    } else {
	      mongoAPI = "https://api.mlab.com/api/1/databases/funily/runComman?apiKey=" + this.mongo
	      db = 'deals'
	    }

	    let toRemove = {
	    	findAndModify: db,
			sort: { dea_code: 1 },
			query: {
				deal_code: dealCode
			},
			update: {
				$pull: {
					deal_ids: redeemCode
				}
			}
	    }

	    //  remove deal id from deal
	    fetch(mongoAPI,{
	    	method: "POST",
	    	headers: {
	    		"Accept": "application/json",
	    		"Content-Type": 'application/json'
	    	},
	    	body: JSON.stringify(toRemove)
	    }).then(res => {return res.json()})
	      .then(function(jsonRes){

	      	this.loadDeals()

	  	  }.bind(this))
	      .catch(err => console.log('error removing deal id', err))

	}

	render() {
		return (
			<div style={styles.container}>
				<Paper style={styles.paper}>
				<form onSubmit={this.handleSubmit}>
					<div style={styles.container} className='text-center'>
						<div>
							<Input placeholder="ENTER REDEEM CODE"
								   style={styles.input}
								   onChange={this.handleChange}
								   autoFocus
							/>
						</div>
						<div>
							<Button
								variant='raised'
								color='secondary'
								style={styles.button}
								type='submit'
							>Check
							</Button>
						</div>
						<div>
							<h3 className='text-center'>{this.state.confirm}</h3>
						</div>
					</div>
					</form>
				</Paper>
			</div>
		);
	}
}

const styles ={
	container: {
		flex: 1,
		justifyContent: 'center'
	},
	button: {
		fontSize: 20,
		width: "60%",
		marginTop: 20
	},
	paper: {
		padding: 100
	},
	input: {
		border: '1px solid lightgrey',
		width: "60%",
		fontSize: 40,
		paddingLeft: 20
	}
}



// WEBPACK FOOTER //
// ./src/components/vendor/Redeem.js